if (document.querySelector('[js-variant-picker="checkbox"]')) {

	/**
	 * Update product hidden input with selected product variant id.
	 */
	document.addEventListener('change', function (e) {
		const input = e.target;

		if (input.matches('[js-variant-picker="checkbox"]')) {
			const variantId = input.dataset.variantId;
			if (!variantId) return;

			const productCard = input.closest('[data-product-id]')
				|| input.closest('[js-variant-picker="product"]')

			if (!productCard) return;

			const hiddenInput = productCard.querySelector('[js-variant-picker="product-id"]');
			if (!hiddenInput) return;

			hiddenInput.value = variantId;
		}
	});
}
